import React, { useState, useEffect } from "react";
import { useTransition, animated } from "react-spring";
import ProgressBar from "../../ProgressBar";
import { stepStyles } from "../formStyles";

export const WhereAreYouLookingToBuildTheHome = ({ formData, setForm, navigation }) => {
  const { city, state } = formData;
  const [stateArray, setStateArray] = useState([]);
  const [cityError, setCityError] = useState(false);
  const [stateError, setStateError] = useState(false);

  const [isVisible] = useState(true);
  const [toolTip, setToolTip] = useState(false);

  const transition = useTransition(isVisible, {
    from: { opacity: 0, transform: "translate3d(500px,0px,0)" },
    enter: { opacity: 1, transform: "translate3d(0,0px,0)" },
  });

  useEffect(() => {
    getStatesList();
    async function getStatesList() {
      // graphql query string to get list of states
      const statesListQuery = `{
      statesList {
        abbreviation
        name
      }
    }`;

      const res = await fetch("https://graphql-onetrust.herokuapp.com/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ query: statesListQuery }),
      });

      const statesList = await res.json();
      setStateArray(statesList.data.statesList);
      return statesList;
    }
  }, []);
  console.log(stateArray);

  const checkForNextStep = () => {
    if (formData.city === "") {
      setCityError(true);
      console.log("error");
    }
    if (formData.state === "") {
      setStateError(true);
      console.log("error");
    }

    if (formData.state !== "" && formData.city !== "") {
      navigation.next();
      console.log("next");
    }
  };

  function leaveToolTip() {
    setTimeout(() => {
      setToolTip(false);
    }, 2000);
  }
  return (
    <div className={stepStyles.page}>
      <ProgressBar width={"40%"} />
      <div className={stepStyles.content}>
        {transition((style, item) =>
          item ? (
            <animated.div style={style} className={stepStyles.panel}>
              <h1 className={stepStyles.title}>Where are you looking to build the home?</h1>
              <div className={stepStyles.fieldStack}>
                <div>
                  <div className={stepStyles.fieldRow}>
                    <input
                      name="city"
                      value={city}
                      onChange={setForm}
                      id="city"
                      className={stepStyles.input}
                      placeholder="City"
                    />
                    <label className={stepStyles.fieldLabel}>City</label>
                  </div>
                  {cityError ? <p className={stepStyles.error}>please fill out an answer</p> : null}
                </div>
                <div className="relative">
                  <div className={stepStyles.fieldRow}>
                    <select name="state" value={state} onChange={setForm} id="state" className={stepStyles.select}>
                      {stateArray.map((state) => (
                        <option key={state.abbreviation} value={state.abbreviation}>
                          {state.name}
                        </option>
                      ))}
                    </select>
                    <label className={stepStyles.fieldLabel}>State</label>
                    <div
                      onMouseEnter={() => setToolTip(true)}
                      onMouseLeave={leaveToolTip}
                      className={stepStyles.tooltipTrigger}
                    >
                      {toolTip ? (
                        <div onMouseEnter={() => setToolTip(true)} className={stepStyles.tooltipCard}>
                          <p className="text-sm text-white p-4">
                            We are able to provide home financing solutions to clients in the states in which we are
                            licensed as Warp Speed Mortgage.
                          </p>
                        </div>
                      ) : null}
                      ?
                    </div>
                  </div>
                  {stateError ? <p className={stepStyles.error}>please fill out an answer</p> : null}
                </div>
              </div>
            </animated.div>
          ) : null,
        )}
      </div>
      <div className={stepStyles.actionBar}>
        <div className={stepStyles.actionRow}>
          <div className="w-full md:w-auto">
            <button className={`${stepStyles.button} w-full`} onClick={() => checkForNextStep()}>
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
